import React, { useState } from 'react';
import { i18n } from "@translations/i18n";

import { WOWhiteLogo, WF_Logo_Color } from '@assets/index';

import LanguageDropdown from '@components/molecules/LanguageDropdown';

import { LanguageService } from "@webServices/LanguageService";

import './styles.less';
import { platform } from '@constants/config';

const GuestHeader = () => {
    const [langCode, setLangCode] = useState(i18n.language);
    const handleLanguage = (language) => {
        setLangCode(language);
        LanguageService.changeLanguage(language);
    }

    return (
        <div className="guest-header">
            {platform.WO && <img alt="guest page WO logo" src={WOWhiteLogo} />}
            {platform.WITP && <img alt="WF logo color" src={WF_Logo_Color} width={100} height={50} />}
            {platform.WO && <div className="app-language">
                <LanguageDropdown
                    onSelectLanguage={handleLanguage}
                    containerStyle="language-container"
                    labelClassName="language-label"
                    dropdownStyle="language-dropdown"
                    preferredLangCode={langCode}
                />
            </div>}
        </div>
    )
}

export default GuestHeader;
